/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_TitleInputs */

const vi_sl_lot_history_title = /** @type {(inputs: Sl_Lot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử nhập / xuất`)
};

/**

* @param {Sl_Lot_History_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_title = /** @type {((inputs?: Sl_Lot_History_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_title(inputs)
});